/**
 * Machina Callida Backend REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * File format for the requested serialization.
 */
export type FileType = 'docx' | 'h5p' | 'json' | 'pdf' | 'xml' | 'zip';

export const FileType = {
    Docx: 'docx' as FileType,
    H5p: 'h5p' as FileType,
    Json: 'json' as FileType,
    Pdf: 'pdf' as FileType,
    Xml: 'xml' as FileType,
    Zip: 'zip' as FileType
};

